<template>
    <div class="video-component">
        <div class="main">
            <div class="video-clone" @click="cloneVideo">×</div>
            <video class="video" controls autoplay loop :src="videoUrl"></video>
        </div>
    </div>
</template>
<script>
export default {
    props:['videoUrl'],
    data(){
        return {

        }
    },
    mounted(){

    },
    methods:{
        cloneVideo(){
            this.$parent.colseVideo()
        }
    }
}

</script>
<style lang="scss" scoped>
.video-component{
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    z-index: 999;
    justify-content: center;
    align-items: center;
    background: rgba($color: #000000, $alpha: 0.6);
    .main{
        width: auto;
        height: auto;
        position: relative;
    }
    .video{
        width: 800px;
        height: auto;
    }
    .video-clone{
        width:30px;
        height:30px;
        position:absolute;
        z-index:999;
        cursor: pointer;
        background:#000;
        right:0;
        font-size:24px;
        line-height: 30px;
        text-align: center;
        color: #fff;
    }
}
@media only screen and (max-width: 1024px){
    .video-component{
        .video{
            width: 100%;
            height: auto;
        }
    }
}
</style>